/**
 * KAN-770: ссылка на файл материала. Файл на API (/api/...) требует токен, голый
 * href открыл бы 401 (в том числе средним кликом), поэтому для него кнопка:
 * картинка открывается в новой вкладке через blob URL, документ скачивается с
 * исходным именем. Ссылка S3 остаётся обычной ссылкой.
 */
import type { ReactNode } from 'react';
import { toast } from 'sonner';
import { downloadApiFile, isApiFileUrl, openApiFile } from '@/services/api/apiFiles';
import type { InstructionAttachment } from '@/services/api/instructionAttachments';
import { isImageMaterial, materialFileName } from './materialFiles';

interface MaterialFileLinkProps {
  item: InstructionAttachment;
  className?: string;
  title?: string;
  children: ReactNode;
}

export function MaterialFileLink({
  item,
  className,
  title,
  children,
}: MaterialFileLinkProps): JSX.Element {
  if (!isApiFileUrl(item.file_url)) {
    return (
      <a href={item.file_url} target="_blank" rel="noreferrer" className={className} title={title}>
        {children}
      </a>
    );
  }
  const open = () => {
    const action = isImageMaterial(item)
      ? openApiFile(item.file_url)
      : downloadApiFile(item.file_url, materialFileName(item));
    action.catch(() => toast.error('Не удалось открыть файл'));
  };
  return (
    <button
      type="button"
      onClick={open}
      title={title}
      className={`${className ?? ''} cursor-pointer border-0 bg-transparent p-0 text-left`}>
      {children}
    </button>
  );
}
